


































import IStock from '@/store/models/IStock';
import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import StockApi from '../store/api/StockApi';
import PrintingApi from '../store/api/PrintingApi';
import CustomerApi from '../store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import StockCustomerSelector from '@/components/selectors/Stock/StockCustomerSelector.vue';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import UploadServiceApi from '../store/api/UploadServiceApi';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import IListPalletType from '@/store/models/IListPalletType';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar,
        StockCustomerSelector
    }
})
export default class CustomerStock extends Vue {
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    StockList : IStock[] = [];
    stockApi : StockApi;
    customerApi : CustomerApi;
    CustomersList : ICustomer[] = [];
    printingApi : PrintingApi;
    settingsCompanyApi: SettingsCompanyApi;
    uploadServiceApi : UploadServiceApi;
    selectedCustomer : ICustomer= {} as ICustomer;
    overlay: boolean = false;
    settingsCompany : any = null;
    idRepport : ISettingsCompany[] = [];
    visiblePrintBtn : boolean = false;
    customerStockCustomFieldsActive : boolean = false;
    listPalletTypeApi : ListPalletTypesApi;
    listPalletTypes : IListPalletType[] = [];
    showSku : boolean = false;
    constructor() {
        super();
        this.stockApi = new StockApi();
        this.customerApi = new CustomerApi();
        this.printingApi = new PrintingApi("CustomerStock");
        this.settingsCompanyApi = new SettingsCompanyApi("CustomerStock");
        this.uploadServiceApi = new UploadServiceApi("CustomerStock");
        this.listPalletTypeApi = new ListPalletTypesApi();
    }

    created() {
        this.getPermissions();
        this.getCustomers();
        this.getRepportId();
        this.getTypesPallets();
    }

    async getTypesPallets() {
        this.listPalletTypes = await this.listPalletTypeApi.GetListPalleTypes();
    }

    async getRepportId() {
        this.settingsCompany = SettingsCompany.Settings.IdStockListCustomerAvailable;
        this.idRepport = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, this.settingsCompany);
        if (this.idRepport.length > 0) {
            this.visiblePrintBtn = true;
        }
    }

    get isSuperAdmin() {
        return this.idCompany === EMPTY_GUID;
    }

    async printCustomerStock(formatToPrint : string, warehouseName: string[], bestBeforeDate: string[], inboundCode: string[], goodName: string[]) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
           
            if (this.idRepport.length > 0) {
                let idCustomer : string[] = ["'" + this.selectedCustomer.id + "'"];
                let warehouseNames: string[] = [];
                let bestBeforeDates: string[] = [];
                let inboundCodes: string[] = [];
                let goodNames: string[] = [];
                if (warehouseName.length > 0) {
                    warehouseName.forEach(i => warehouseNames.push("'" + i + "'"));
                }
                if (bestBeforeDate.length > 0) {
                    bestBeforeDate.forEach(i => {
                        bestBeforeDates.push("'" + i + "'");
                    });
                }
                if (inboundCode.length > 0) {
                    inboundCode.forEach(i => {
                        inboundCodes.push("'" + i + "'");
                    });
                }
                if (goodName.length > 0) {
                    goodName.forEach(i => {
                        goodNames.push("'" + i + "'");
                    });
                }
                let printLabelUrl: string = await this.printingApi.PrintCustomerStock(this.idRepport[0].value, idCustomer, warehouseNames, bestBeforeDates, inboundCodes, goodNames, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "CustomerStock.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + this.settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            if (this.selectedCustomer === undefined || Object.keys(this.selectedCustomer).length === 0) {
                this.showMessageWarning("First select a customer, to be able to print the stock.");
            } else {
                this.showMessageWarning("SuperAdmin has not company settings.");
            }
        }
    }

    async getCustomers() {
        this.CustomersList = await this.customerApi.GetCustomersByCompanyId(this.idCompany);
    }

    async getStockSelectedCustomer(customer: ICustomer) {
        this.overlay = true;
        this.selectedCustomer = customer;
        this.StockList = await this.stockApi.GetStockGroupByCustomer(customer.id);
        this.overlay = false;
    }

    async groupByPalletAndCustomer(customer: ICustomer, groupByActive: boolean) {
        this.overlay = true;
        if (groupByActive) {
            this.StockList = await this.stockApi.GetStockGroupByPalletsAndCustomer(customer.id);
        } else {
            this.StockList = await this.stockApi.GetStockGroupByCustomer(customer.id);
        }
        this.overlay = false;
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Warehouses"));
        let settingsCompany = SettingsCompany.Settings.CustomerStockCustomFields;
        let setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
        let settingsCompanyShowSku = SettingsCompany.Settings.ShowSku;
        let settingShowSku = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompanyShowSku);
        
        if (setting.length > 0) {
            this.customerStockCustomFieldsActive = true;
        }
        if (settingShowSku.length > 0) {
            this.showSku = true;
        }
    }

    async printStockNew(data: any) {
        // data.headers: string[]
        // data.rows: Array<object> donde keys = header text

        const headers: string[] = (data && data.headers) ? data.headers : [];
        const rows: any[] = (data && data.rows) ? data.rows : [];

        if (!headers.length) {
            this.showMessageWarning("Nothing to export (no headers).");
            return;
        }

        // Nombre del fichero: CustomerName + fecha
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        const formattedDate = `${dd}-${mm}-${yyyy}`;

        const sanitize = (t: string) =>
            (t || "").replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_]/g, "");

        const rawCustomerName =
    (this.selectedCustomer && (this.selectedCustomer as any).name)
        ? String((this.selectedCustomer as any).name)
        : "";

        const customerName = rawCustomerName ? sanitize(rawCustomerName) : "Customer";
        const fileName = `${customerName}_${formattedDate}_CUSTOMERSTOCK.xlsx`;

        // Excel
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Customer Stock");

        const getExcelColumnName = (colNumber: number): string => {
            let temp = "";
            let number = colNumber;
            while (number > 0) {
                const remainder = (number - 1) % 26;
                temp = String.fromCharCode(65 + remainder) + temp;
                number = Math.floor((number - 1) / 26);
            }
            return temp;
        };

        const lastColLetter = getExcelColumnName(headers.length);

        // Título
        sheet.mergeCells(`A1:${lastColLetter}1`);
        const titleCell = sheet.getCell("A1");
        titleCell.value = `Customer Stock - ${rawCustomerName} - ${formattedDate}`;
        titleCell.font = { size: 20, bold: true, color: { argb: "FFFFFFFF" } };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
        titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2F75B5" } };
        sheet.getRow(1).height = 58;

        // Header row
        const headerRow = sheet.addRow(headers);
        headerRow.height = 58;
        headerRow.eachCell((cell: any) => {
            cell.font = { bold: true, size: 20, color: { argb: "FFFFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4472C4" } };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        // Data rows (en el mismo orden del array rows)
        rows.forEach((r: any) => {
            const safeRow: any = (r && typeof r === "object") ? r : {};

            const rowValues = headers.map((h: string) => {
                const v = safeRow[h];
                return (v === null || v === undefined) ? "" : v;
            });

            const excelRow = sheet.addRow(rowValues);
            excelRow.height = 58;

            const goodVal = (safeRow["Good"] !== undefined && safeRow["Good"] !== null)
                ? String(safeRow["Good"])
                : "";

            const GOODVal = (safeRow["GOOD"] !== undefined && safeRow["GOOD"] !== null)
                ? String(safeRow["GOOD"])
                : "";

            const isTotalsRow =
                goodVal.toUpperCase().indexOf("TOTAL") !== -1 ||
                GOODVal.toUpperCase().indexOf("TOTAL") !== -1;

            excelRow.eachCell((cell: any, colNumber: number) => {
                const headerText = headers[colNumber - 1] ? String(headers[colNumber - 1]).trim() : "";
                const isAantartColumn = headerText === "Aantart";

                cell.font = { size: 20, bold: !!isTotalsRow };
                cell.alignment = {
                    vertical: "middle",
                    horizontal: "left"
                };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
                if (isTotalsRow) {
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE2EFDA" } };
                }
            });
        });

        // Ajuste ancho columnas
        sheet.columns.forEach((col: any) => {
            let max = 12;
            col.eachCell({ includeEmpty: true }, (cell: any) => {
                const v = cell.value ? cell.value.toString().length : 0;
                if (v > max) max = v;
            });
            col.width = max + 2;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
